import { css } from '@emotion/css';
import * as React from 'react';
const text = css({
  fontSize: '24px',
  lineHeight: '28px',
  fontWeight: 500,
});

interface Props {
  children: React.ReactNode;
}

const LargeHeading = ({ children }: Props) => {
  return <span className={text}>{children}</span>;
};

export default LargeHeading;
